// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__eGUfZ","stylesImage":"Cards_stylesImage__268zm","fontCard":"Cards_fontCard__1zQcK","fontTemperament":"Cards_fontTemperament__2JfU1"};